// name of the constant = route name in lower case
const vehicledetail = [
  {
    id: 1,
    name: 'Vehicle Number',
    query: 'vehicle_number',
  },
];
const users = [
  {
    id: 1,
    name: 'Name',
    query: 'name',
  },
  {
    id: 2,
    name: 'Phone',
    query: 'mobile',
  },
  {
    id: 3,
    name: 'Email',
    query: 'email_id',
  },
];

const driverdetail = [
  {
    id: 1,
    name: 'Mobile Number',
    query: 'mobile_number',
  },
  {
    id: 2,
    name: 'Driver Name',
    query: 'driver_name',
  },
  {
    id: 3,
    name: 'License Number',
    query: 'license_number',
  },
];

// eslint-disable-next-line import/prefer-default-export
const ndc_master = [
  { id: 1, name: 'Quarter', query: 'quarter_name' },
];

export const searchConstants = {
  vehicledetail,
  users,
  driverdetail,
  ndc_master,
};
